module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit(_vm.item)
      }
    }
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.name)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_name"
    }
  }, [_vm._v("Nazwa klienta")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.name),
      expression: "item.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_name"
    },
    domProps: {
      "value": (_vm.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.name) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_name_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.nip)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_nip"
    }
  }, [_vm._v("NIP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.nip),
      expression: "item.nip"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_nip"
    },
    domProps: {
      "value": (_vm.item.nip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "nip", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.nip) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_nip_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.nip))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.regon)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_regon"
    }
  }, [_vm._v("REGON")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.regon),
      expression: "item.regon"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_regon"
    },
    domProps: {
      "value": (_vm.item.regon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "regon", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.regon) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_regon_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.regon))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.pesel)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_pesel"
    }
  }, [_vm._v("PESEL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.pesel),
      expression: "item.pesel"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_pesel"
    },
    domProps: {
      "value": (_vm.item.pesel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "pesel", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.pesel) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_pesel_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.pesel))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.krs)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_krs"
    }
  }, [_vm._v("KRS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.krs),
      expression: "item.krs"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_pesel"
    },
    domProps: {
      "value": (_vm.item.krs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "krs", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.krs) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_pesel_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.krs))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    class: {
      'form-group col-lg-12': true, 'has-error': (_vm.errors && _vm.errors.commission)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_commission"
    }
  }, [_vm._v("Prowizja")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "_commission"
    },
    model: {
      value: (_vm.item.commission),
      callback: function($$v) {
        _vm.$set(_vm.item, "commission", $$v)
      },
      expression: "item.commission"
    }
  })], 1), _vm._v(" "), (_vm.errors && _vm.errors.commission) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_commission_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.commission))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    class: {
      'form-group col-lg-8': true, 'has-error': (_vm.errors && _vm.errors.address && _vm.errors.address.street)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_street"
    }
  }, [_vm._v("Ulica")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.address.street),
      expression: "item.address.street"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_street"
    },
    domProps: {
      "value": (_vm.item.address.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.address, "street", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.address && _vm.errors.address.street) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_street_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.address.street))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group col-lg-4': true, 'has-error': (_vm.errors && _vm.errors.address && _vm.errors.address.number)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_number"
    }
  }, [_vm._v("Numer domu")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.address.number),
      expression: "item.address.number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_number"
    },
    domProps: {
      "value": (_vm.item.address.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.address, "number", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.address && _vm.errors.address.number) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_number_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.address.number))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    class: {
      'form-group col-lg-4': true, 'has-error': (_vm.errors && _vm.errors.address && _vm.errors.address.postalCode)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_postalCode"
    }
  }, [_vm._v("Kod pocztowy")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.address.postalCode),
      expression: "item.address.postalCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_postalCode"
    },
    domProps: {
      "value": (_vm.item.address.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.address, "postalCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.address && _vm.errors.address.postalCode) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_postalCode_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.address.postalCode))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group col-lg-8': true, 'has-error': (_vm.errors && _vm.errors.address && _vm.errors.address.city)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_address_city"
    }
  }, [_vm._v("Miasto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.address.city),
      expression: "item.address.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_address_city"
    },
    domProps: {
      "value": (_vm.item.address.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.address, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.address && _vm.errors.address.city) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_address_city_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.address.city))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.bankAccount && (_vm.errors.bankAccount.numberPLN || _vm.errors.bankAccount.bankAccountSet))
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_bankAccount_numberPLN"
    }
  }, [_vm._v("Numer konta bankowego (PLN)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.bankAccount.numberPLN),
      expression: "item.bankAccount.numberPLN"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_bankAccount_numberPLN"
    },
    domProps: {
      "value": (_vm.item.bankAccount.numberPLN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.bankAccount, "numberPLN", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.bankAccount && _vm.errors.bankAccount.numberPLN) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_bankAccount_numberPLN_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.bankAccount.numberPLN))]) : _vm._e(), _vm._v(" "), (_vm.errors && _vm.errors.bankAccount && _vm.errors.bankAccount.bankAccountSet) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_bankAccount_number_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.bankAccount.bankAccountSet))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.bankAccount && (_vm.errors.bankAccount.numberEUR || _vm.errors.bankAccount.bankAccountSet))
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_bankAccount_numberEUR"
    }
  }, [_vm._v("Numer konta bankowego (EUR)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.bankAccount.numberEUR),
      expression: "item.bankAccount.numberEUR"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_bankAccount_numberEUR"
    },
    domProps: {
      "value": (_vm.item.bankAccount.numberEUR)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.bankAccount, "numberEUR", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.bankAccount && _vm.errors.bankAccount.numberEUR) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_bankAccount_numberEUR_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.bankAccount.numberEUR))]) : _vm._e(), _vm._v(" "), (_vm.errors && _vm.errors.bankAccount && _vm.errors.bankAccount.bankAccountSet) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_bankAccount_number2_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.bankAccount.bankAccountSet))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.contact && _vm.errors.contact.email)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_contact_email"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.contact.email),
      expression: "item.contact.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_contact_email"
    },
    domProps: {
      "value": (_vm.item.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.contact, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.contact && _vm.errors.contact.email) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_contact_email_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.contact.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group col-lg-6': true, 'has-error': (_vm.errors && _vm.errors.contact && _vm.errors.contact.phone)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_contact_phone"
    }
  }, [_vm._v("Numer telefonu")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.contact.phone),
      expression: "item.contact.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_contact_phone"
    },
    domProps: {
      "value": (_vm.item.contact.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item.contact, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.contact && _vm.errors.contact.phone) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_contact_phone_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.contact.phone))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.comments)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_comments"
    }
  }, [_vm._v("Uwagi")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.comments),
      expression: "item.comments"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "_comments"
    },
    domProps: {
      "value": (_vm.item.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "comments", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.comments) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_comments_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.comments))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'CustomerList'
      }
    }
  }, [_c('span', [_vm._v("Powrót")]), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1), _vm._v(" "), _c('my-button', {
    attrs: {
      "text": "Zapisz",
      "icon": "tick",
      "type": "submit"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e06957a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer/Form.vue
// module id = 814
// module chunks = 0